export default {
      id: "calendar-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#calendar",
      toString: function () {
        return this.url;
      }
    }